// extracted by mini-css-extract-plugin
export var active = "DocumentInformation-module--active--b5367";
export var arrow = "DocumentInformation-module--arrow--d2877";
export var arrowNo = "DocumentInformation-module--arrow_no--7f25f";
export var arrowYes = "DocumentInformation-module--arrow_yes--04409";
export var contentContainer = "DocumentInformation-module--contentContainer--49b2a";
export var documentImage = "DocumentInformation-module--documentImage--e7775";
export var documentInformationModal = "DocumentInformation-module--documentInformationModal--3e183";
export var documentLanguageDropdownLabel = "DocumentInformation-module--documentLanguageDropdownLabel--e1b37";
export var documentTitle = "DocumentInformation-module--documentTitle--d17a9";
export var flex = "DocumentInformation-module--flex--eacfa";
export var flex1 = "DocumentInformation-module--flex_1--34e3b";
export var flexCenter = "DocumentInformation-module--flex_center--ec6fd";
export var flexCenterCol = "DocumentInformation-module--flex_center_col--bb2c8";
export var flexCol = "DocumentInformation-module--flex_col--21fad";
export var flexFixCenterCol = "DocumentInformation-module--flex_fix_center_col--fb943";
export var flexFixedCenterCol = "DocumentInformation-module--flex_fixed_center_col--83714";
export var languageWrapper = "DocumentInformation-module--languageWrapper--7273e";
export var languageWrapperLabel = "DocumentInformation-module--languageWrapperLabel--7a7d3";
export var languagesContainer = "DocumentInformation-module--languagesContainer--3b25c";
export var left = "DocumentInformation-module--left--ca25f";
export var referenceContainer = "DocumentInformation-module--referenceContainer--01117";
export var right = "DocumentInformation-module--right--4207c";
export var rotating = "DocumentInformation-module--rotating--7bbf5";
export var shareContainer = "DocumentInformation-module--shareContainer--f3d8a";
export var shareIcon = "DocumentInformation-module--shareIcon--653b9";
export var shareIconsContainer = "DocumentInformation-module--shareIconsContainer--b06f5";
export var toggleViewButton = "DocumentInformation-module--toggleViewButton--6870a";
export var toggleViewContainer = "DocumentInformation-module--toggleViewContainer--68d10";
export var topRow = "DocumentInformation-module--topRow--0096d";